import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductHome } from '@/features/home'
import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'
import { useDigitalProductBackground } from '@/shared/hooks/useDigitalProductBackground'
import { HomeSkeleton } from '@/features/home/components/HomeSkeleton'

export const Route = createFileRoute('/_event/')({
  // Declarado ao lado do componente que ele representa: rota nova nasce
  // coberta pelo default, e nenhum registro central precisa ser lembrado.
  staticData: { bootSkeleton: HomeSkeleton },
  component: DigitalProductHomePage
})

function DigitalProductHomePage() {
  const { digitalProduct } = useDigitalProductContext()
  useDigitalProductBackground(digitalProduct, { withCssVars: false })
  return <DigitalProductHome />
}
